export function snapToGrid(x: number, y: number): [number, number] {
    const snappedX = Math.round(x / 3) * 3
    const snappedY = Math.round(y / 2) * 2
    return [snappedX, snappedY]
  }
  